import React from 'react';

const Smartphone = ({ ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.6719 2.67188H9.33854C7.86578 2.67188 6.67188 3.86578 6.67188 5.33854V26.6719C6.67188 28.1446 7.86578 29.3385 9.33854 29.3385H22.6719C24.1446 29.3385 25.3385 28.1446 25.3385 26.6719V5.33854C25.3385 3.86578 24.1446 2.67188 22.6719 2.67188Z"
      stroke="#00396A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 24H16.0133"
      stroke="#00396A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Smartphone;
